<template>
  <section class="pb-4">
    <div class="row">
      <div class="col-12">
        <h2>{{ $t('message.notification_settings.title') }}</h2>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-8">
        &nbsp;
      </div>
      <div class="col-2 text-center">
        <label>
          {{ $t('message.notification_settings.email') }}
        </label>
      </div>
      <div class="col-2 text-center">
        <label>
          {{ $t('message.notification_settings.sms') }}
        </label>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-8">
        <label>{{ $t('message.notification_settings.reminders') }}</label>
      </div>
      <div class="col-2">&nbsp;</div>
      <div class="col-2">&nbsp;</div>
    </div>
    <div class="row">
      <div class="col-8">
        {{ $t('message.notification_settings.reminders_detail') }}
      </div>
      <div class="col-2 text-center">
        <input type="checkbox"
               :true-value="1"
               :false-value="0"
               @change="updateUserSetting"
               v-model="userSetting.notification_reminders_email">
      </div>
      <div class="col-2 text-center">
        <input type="checkbox"
               :true-value="1"
               :false-value="0"
               @change="updateUserSetting"
               v-model="userSetting.notification_reminders_sms">
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <hr>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-8">
        <label>{{ $t('message.notification_settings.messages') }}</label>
      </div>
      <div class="col-2">&nbsp;</div>
      <div class="col-2">&nbsp;</div>
    </div>
    <div class="row">
      <div class="col-8">
        {{ $t('message.notification_settings.messages_detail') }}
      </div>
      <div class="col-2 text-center">
        <input type="checkbox"
               :true-value="1"
               :false-value="0"
               @change="updateUserSetting"
               v-model="userSetting.notification_messages_email">
      </div>
      <div class="col-2 text-center">
        <input type="checkbox"
               :true-value="1"
               :false-value="0"
               @change="updateUserSetting"
               v-model="userSetting.notification_messages_sms">
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <hr>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-8">
        <label>{{ $t('message.notification_settings.news_promotions') }}</label>
      </div>
      <div class="col-2">&nbsp;</div>
      <div class="col-2">&nbsp;</div>
    </div>
    <div class="row">
      <div class="col-8">
        {{ $t('message.notification_settings.news_promotions_detail') }}
      </div>
      <div class="col-2 text-center">
        <input type="checkbox"
               :true-value="1"
               :false-value="0"
               @change="updateUserSetting"
               v-model="userSetting.notification_promotions_email">
      </div>
      <div class="col-2 text-center">
        <input type="checkbox"
               :true-value="1"
               :false-value="0"
               @change="updateUserSetting"
               v-model="userSetting.notification_promotions_sms">
      </div>
    </div>
  </section>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'

  export default {
    computed: {
      ...mapGetters({
        user: 'auth/getUser'
      }),
      ...mapState('userSetting', [
        'userSetting'
      ])
    },
    methods: {
      updateUserSetting () {
        let submitData = {
          id: this.userSetting.id,
          formData: {}
        }
        for (let key in this.userSetting) {
          if (key !== 'id') {
            submitData.formData[key] = this.userSetting[key]
          }
        }
        this.$store.dispatch('userSetting/UPDATE_USER_SETTING', submitData)
      }
    },
    mounted () {
      this.$store.dispatch('userSetting/LOAD_USER_SETTING', this.user.id)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/user/Notification.vue